const problems = [
  {
    question: 'Bu kişi gerçekten müşteri olabilir mi?',
    detail: 'Gelen mesajların niteliğini ve kişinin gerçek satın alma potansiyelini ölçmek klasik yöntemlerle mümkün değildir.',
    icon: 'ri-user-search-line',
  },
  {
    question: 'Sadece fiyat sorup kaybolacak biri mi?',
    detail: 'Fiyat sorgulayan ile gerçekten hizmet değerlendiren kişiyi ayırt etmek zaman ve emek kaybını önler.',
    icon: 'ri-question-answer-line',
  },
  {
    question: 'Gönderilen bilgileri inceledi mi?',
    detail: 'Kişinin paylaştığınız içeriklerle ne kadar etkileşime girdiğini bilmek, ilgi seviyesini anlamanızı sağlar.',
    icon: 'ri-file-search-line',
  },
  {
    question: 'Randevuya ya da satışa yakın mı?',
    detail: 'Her başvuru aynı aşamada değildir. Satışa yakın olanları önceliklendirmek dönüşüm oranını artırır.',
    icon: 'ri-calendar-check-line',
  },
  {
    question: 'Hangi reklamdan gelen kişi daha kaliteli?',
    detail: 'Farklı reklam kampanyalarından gelen kişilerin kalitesini karşılaştırmak, bütçe optimizasyonu için kritiktir.',
    icon: 'ri-advertisement-line',
  },
  {
    question: 'Hangi müşteri tipi bana daha çok para kazandırıyor?',
    detail: 'Davranış verileriyle en karlı müşteri profillerini belirlemek, uzun vadede reklam stratejinizi şekillendirir.',
    icon: 'ri-line-chart-line',
  },
];

export default function ProblemSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" id="problem">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Bugün Reklam Vermek Yetmiyor.
            <br />
            Gelen Kişinin <span className="text-accent-600">Kalitesini Anlamak</span> Gerekiyor.
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Birçok firma reklam veriyor, mesaj alıyor ama şu soruların cevabını net göremiyor:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {problems.map((item) => (
            <div
              key={item.question}
              className="group p-5 md:p-6 rounded-xl bg-background-100/70 border border-background-200/50 hover:border-accent-200/50 transition-all duration-300 cursor-default"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {item.question}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.detail}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-foreground-500 text-sm max-w-2xl mx-auto">
            Klasik reklam yönetiminde çoğu zaman sadece tıklama, mesaj ve maliyet görülür. <strong className="text-foreground-800">Bizim odaklandığımız yer ise gelen kişinin davranışı ve satışa yakınlığıdır.</strong>
          </p>
        </div>
      </div>
    </section>
  );
}